export default "__VITE_PUBLIC_ASSET__dacd4875__"